/* eslint-disable no-unused-expressions */
import Base from './base'
import Vue from 'vue'
import cache from '../assets/lib/cache'
import comm from '../assets/lib/comm'
import scene from './scene'
import linkage from './linkage'
import { Message } from 'element-ui'
import event from '../model/event'
import sysConfig from '../model/config'
import $store from '@/store'
class Zone extends Base {
  constructor () {
    super('Zone')
  }

  async getBasicInfo () {
    const loading = comm.showLoading('#app')
    try {
      if (!cache.getSession('dtit_user')) {
        return
      }
      // 实时获取网关是设备状态
      await this.getStatus()
      let zone = await this.getZone(cache.getSession('dtit_user').no)
      zone = zone.data[0]
      Vue._logger.debugger(zone)
      // 获取树
      let tree = await this.getZoneTree(zone.id)
      zone.tree = tree
      // 保存zone的信息
      $store.commit('SET_ZONE', zone)
      // 获取环境修复参数
      this.loadSensorRepair(zone)
      // 加载场景
      await scene.load(zone.id)
      // 加载区域的配置信息
      this.loadZoneConfig(zone.id)
      // // 加载课程数据
      let subject = await this.getSubjectByZone(zone.id)
      if (subject) {
        Vue._logger.debugger(subject)
        $store.commit('SET_SUBJECT', subject.data)
      }
      // 加载通知数据
      let notify = await this.getNotifyByZone(zone.id)
      if (notify) {
        Vue._logger.debugger(notify)
        notify.data.sort((a, b) => {
          return new Date(a.updatedAt).getTime() - new Date(b.updatedAt).getTime()
        })
        $store.commit('SET_NOTIFY', notify.data)
      }
      // 获取天气信息
      let weather = await this.getWeatherByZone(zone.id)
      if (weather) {
        Vue._logger.debugger(weather)
        // if (weather.data && weather.data["HeWeather5"] && weather.data["HeWeather5"].length) {
        //   $store.commit("SET_WEATHER", weather.data["HeWeather5"][0].now);
        // }
        // 使用新的天气接口，不同的天气数据结构
        if (weather.data) {
          $store.commit('SET_WEATHER', weather.data)
        }
      }
      // 加载控制器
      let devices = await this.getDeviceByZone(zone.id)
      if (devices) {
        Vue._logger.debugger(devices)
        if (!devices.data || !devices.data.length) {
          // 未找到控制器信息，返回提示
          Message.error('未发现网关设备，请联系管理员')
          return
        }
        $store.commit(
          'SET_COREIDS',
          devices.data.map((item) => item.coreid)
        )
      }
      // 加载灯具
      let lights = await this.getLightByZone(zone.id)
      Vue._logger.debugger(lights)
      // 加载外部其他设备
      let ext = await this.getExtDeviceByZone(zone.id)
      Vue._logger.debugger(ext)
      // 加载其他外部其他设备
      let otherExt = await this.getOtherExtDeviceByzone(zone.id)
      if (otherExt && otherExt.length) {
        // 获取token
        let token = await this.getOtherExtDeviceByToken()
        if (token) {
          // 获取其他外部其他设备
          let otherExtState = await this.getOtherExtState(otherExt.map((item) => item.unique))
          // 更新外部设备列表的状态
          this.upadataOtherExtState(otherExt, otherExtState)
        }
      }

      // 获取环境及设备状态信息
      let deviceState = await this.getSensorByDevice(devices.data.map((d) => d.coreid))
      Vue._logger.debugger(deviceState)
      this.getSensorByState(devices.data, deviceState.data)
      this.getLightByState(lights.data, deviceState.data)
      this.getExtDeviceByState(ext.data, deviceState.data)
      // 如果是大工会议室，则同时加载lora
      if (zone.id === 1362) {
        let deviceStateLora = await this.getSensorByDevice(['27002d001347343133363638'])
        let ariState = deviceStateLora.data['27002d001347343133363638']['airswitch'].filter((air) => parseInt(air.nd) === 185 && air.addr === 7)[0]
        let extDevices = $store.state.extDevices
        extDevices[2].state = ariState
        $store.commit('SET_EXT', extDevices)
        $store.commit('SET_EXTS', extDevices)
      }
      // ----控制面板
      if (deviceState.data && Object.keys(deviceState.data) > 0) {
        let stateObj = deviceState.data[Object.keys(deviceState.data)[0]]
        $store.commit('SET_REMOTES', stateObj.remote)
      }
      // -----
      $store.commit('SET_DEVICE', devices.data)
      window.vm.$hub.devices = devices.data
      // 生成设备菜单，当前主要包含的菜单有 照明、空调、窗帘、新风、风扇、智能插座、监控
      this.filterMenus(zone.id, lights.data, ext.data, devices.data, otherExt)
      // 获取智联配置 ---- 新版有该功能
      if (devices.data[0]['version'] >= 45) {
        this.getLinkAge(zone.id, $store.state.coreIds)
      }
    } catch (e) {
      throw e
    } finally {
      event.connect()
      comm.closeLoading(loading)
    }
  }
  async getStatus () {
    try {
      Vue._logger.debugger(Vue._config.api.status)
      const result = await Vue.axios.get(Vue._config.api.status)
      if (result.data.code !== 1) {
        throw new Error('获取网关在线状态失败')
      }
    } catch (e) {
      Vue._logger.error(e.message, e)
    }
  }
  async getLinkAge (id, coreIds) {
    let ext = $store.state.extDevicesNdOrign
    let isSuperSensor = false
    let isHumanSensor = false
    let isLightSensor = false
    ext.forEach((item) => {
      if (item.devicenodetype === 1) {
        isSuperSensor = true
      }
      if (item.devicenodetype === 3) {
        isHumanSensor = true
      }
      if (item.devicenodetype === 2) {
        isLightSensor = true
      }
    })

    let device = $store.state.deviceMenus.map((item) => item.name).slice(1)
    let result = await linkage.getLinkAge(id)
    if (!result.length) {
      let results = await linkage.saveLinkAge({ zoneId: id, deviceId: coreIds, rule: $store.state.linkage.rule })
      $store.commit('SET_LINKAGE', { id: results.id, rule: JSON.parse(results['rule']) })
    } else {
      let data = result[result.length - 1]
      // 固定配置入库后不能修改，所以这边更新一下
      let origin = $store.state.linkage.rule
      let obj = JSON.parse(data['rule'])
      obj.forEach((item, index) => {
        item.icon = origin[index].icon
        item.name = origin[index].name
        item.viewRange = origin[index].viewRange
        item.type = origin[index].type
      })
      $store.commit('SET_LINKAGE', { id: data.id, rule: obj })
    }
    // 处理是否有设备，满足现实需求
    let devicesType = [
      {
        text: '照明',
        name: 'light'
      },
      {
        text: '空调',
        name: 'aircon'
      },
      {
        text: '窗帘',
        name: 'curtain'
      },
      {
        text: '新风',
        name: 'airpure'
      },
      {
        text: '风扇',
        name: 'fan'
      },
      {
        text: '智能插座',
        name: 'switch'
      },
      // {
      //   text: '加湿器',
      //   src: require('./assets/images/device/jsq.png'),
      //   activeSrc: require('./assets/images/device/jsq-k.png'),
      //   isActive: false,
      //   name: 'humidifier'
      // },
      {
        text: '监控',
        name: 'video'
      }
    ]
    let linkages = JSON.parse(JSON.stringify($store.state.linkage))
    linkages.rule.forEach((item) => {
      let isDevice = item.action.some((itms) => device.includes(itms.type))
      if (item.type === 'ALS') {
        item.isShow = isLightSensor && isDevice
      } else if (item.type === 'PIR') {
        item.isShow = isHumanSensor && isDevice
      } else {
        item.isShow = isSuperSensor && isDevice
      }

      let noDeviceType = item.action.filter((itms) => !device.includes(itms.type)).map((itms) => itms.type)
      item.noDeviceType = devicesType.map((itms) => {
        if (noDeviceType.includes(itms.name)) {
          return itms.text
        }
      })
      if (item.type === 'ALS' && !isLightSensor) {
        item.noDeviceType.unshift('光感')
      } else if (item.type === 'PIR' && !isHumanSensor) {
        item.noDeviceType.unshift('人感')
      } else if (!isSuperSensor) {
        item.noDeviceType.unshift('超感')
      }

      item.noDeviceType = item.noDeviceType.filter((itms) => itms && itms.trim()).join('、')
      item.action.forEach((itms) => {
        itms.isShow = device.includes(itms.type)
      })
    })
    $store.commit('SET_LINKAGE', linkages)
  }

  async getZone (no) {
    try {
      Vue._logger.debugger(Vue._config.api.zone)
      const result = await Vue.axios.get(Vue._config.api.zone, { params: { no: no } })
      if (result.data.code === 1) {
        return result.data
      } else {
        throw new Error('获取区域信息失败')
      }
    } catch (e) {
      Vue._logger.error(e.message, e)
    }
  }

  async getNotifyByZone (zoneId) {
    try {
      Vue._logger.debugger(Vue._config.api.notify)
      const result = await Vue.axios.get(Vue._config.api.notify.replace(':zoneId', zoneId))
      if (result.data.code === 1) {
        return result.data
      } else {
        throw new Error('获取通知信息失败')
      }
    } catch (e) {
      Vue._logger.error(e.message, e)
    }
  }

  async loadZoneConfig (zoneId) {
    // 加载收藏信息
    this.loadCollectionScenes(zoneId)
    this.loadCollectionDevices(zoneId)
    // 加载区域配置信息
    this.loadControlDevices(zoneId)
    // 新版加载组配置信息
    this.loadCollectionGroups(zoneId)
  }

  async loadCollectionScenes (zoneId) {
    let zoneConfig = await this.getZoneConfig(zoneId, 'collectionScenes')
    // 如果场景没有任何收藏，默认给三个放进去
    if (!zoneConfig || zoneConfig.configs === '[]') {
      const scenes = []
      $store.state.scenes.forEach((s, i) => {
        i < 3 && scenes.push({ id: s.id, remark: s.name })
      })
      $store.commit('SET_COLLECTION', { scenes: scenes })
    } else {
      zoneConfig = JSON.parse(zoneConfig.configs)
      const exist = zoneConfig
        .map((cs) => {
          const s = $store.state.scenes
            .filter((sc) => sc.id === cs.id)
            .map((sc) => {
              return { id: sc.id, remark: sc.name }
            })
          if (s.length) {
            return s[0]
          } else {
            return 0
          }
        })
        .filter((s) => s !== 0)
      const scenes = []
      if (!exist.length) {
        $store.state.scenes.forEach((s, i) => {
          i < 3 && scenes.push({ id: s.id, remark: s.name })
        })
        $store.commit('SET_COLLECTION', { scenes: scenes })
      } else {
        $store.commit('SET_COLLECTION', { scenes: exist })
      }
    }
  }

  async loadCollectionDevices (zoneId) {
    let zoneConfig = await this.getZoneConfig(zoneId, 'collectionDevices')
    if (zoneConfig) {
      $store.commit('SET_COLLECTION', { devices: (zoneConfig && JSON.parse(zoneConfig.configs)) || [] })
    }
  }

  async loadControlDevices (zoneId) {
    let zoneConfig = await this.getZoneConfig(zoneId, 'controlDevices')
    if (zoneConfig) {
      $store.commit('SET_CONFIG', (zoneConfig && JSON.parse(zoneConfig.configs)) || null)
    }
  }
  async loadCollectionGroups (zoneId) {
    let zoneConfig = await this.getZoneConfig(zoneId, 'collectionGroups')
    if (zoneConfig) {
      $store.commit('SET_GROUPS', (zoneConfig && JSON.parse(zoneConfig.configs)) || null)
    }
  }

  async loadSensorRepair (zone) {
    const result = await sysConfig.get('sensorRepair')
    // 循环查找
    if (result.code === 1) {
      result.data.rows.forEach((setting) => {
        // 查找到对应的数据，并保存配置
        try {
          const value = JSON.parse(setting.value)
          if (value && value.zone.includes(zone.no)) {
            // 设置当前修复参数
            $store.commit('SET_REPAIR', value.sensor)
          }
        } catch (e) {
          Vue._logger.error('配置格式异常', e)
        }
      })
    }
  }

  async getZoneConfig (zoneId, name) {
    try {
      Vue._logger.debugger(Vue._config.api.zoneConfig)
      const result = await Vue.axios.get(Vue._config.api.zoneConfig, {
        params: {
          zoneId: zoneId,
          name: name
        }
      })
      if (result.data.code === 1) {
        return result.data.data
      } else {
        return null
      }
    } catch (e) {
      Vue._logger.error(e.message, e)
    }
  }

  async setZoneConfig (zoneId, name, configs) {
    try {
      Vue._logger.debugger(Vue._config.api.zoneConfig)
      const result = await Vue.axios.put(Vue._config.api.zoneConfig, {
        zoneId: zoneId,
        name: name,
        type: 1,
        configs: configs
      })
      if (result.data.code === 1) {
        return result.data
      } else {
        return null
      }
    } catch (e) {
      Vue._logger.error(e.message, e)
    }
  }

  async getSubjectByZone (zoneId) {
    try {
      Vue._logger.debugger(Vue._config.api.subject)
      const result = await Vue.axios.get(Vue._config.api.subject.replace(':zoneId', zoneId))
      if (result.data.code === 1) {
        return result.data
      } else {
        throw new Error('获取课程信息失败')
      }
    } catch (e) {
      Vue._logger.error(e.message, e)
    }
  }

  async getDeviceByZone (zoneId) {
    try {
      Vue._logger.debugger(Vue._config.api.device)
      const result = await Vue.axios.get(Vue._config.api.device.replace(':zoneId', zoneId))
      if (result.data.code === 1) {
        return result.data
      } else {
        throw new Error('获取设备信息失败')
      }
    } catch (e) {
      Vue._logger.error(e.message, e)
    }
  }

  async getLightByZone (zoneId) {
    try {
      Vue._logger.debugger(Vue._config.api.light)
      const result = await Vue.axios.get(Vue._config.api.light.replace(':zoneId', zoneId))
      if (result.data.code === 1) {
        // 暂时做下处理相同 device_no 只显示一条
        // let obj = {}
        // result.data.data = result.data.data.reduce((cur, next) => {
        //   obj[next.device_no] ? '' : obj[next.device_no] = true && cur.push(next)
        //   return cur
        // }, [])
        let obj = {}
        result.data.data = result.data.data.reduce((cur, next) => {
          if (!(obj[next.deviceId] && obj[next.deviceId][next.device_no])) {
            if (!obj[next.deviceId]) obj[next.deviceId] = {}
            obj[next.deviceId][next.device_no] = true
            cur.push(next)
          }
          return cur
        }, [])
        result.data.data.sort((a, b) => {
          return a.nodeId - b.nodeId
        })
        return result.data
      } else {
        throw new Error('获取灯具信息失败')
      }
    } catch (e) {
      Vue._logger.error(e.message, e)
    }
  }

  async getExtDeviceByZone (zoneId) {
    try {
      Vue._logger.debugger(Vue._config.api.extDevice)
      const result = await Vue.axios.get(Vue._config.api.extDevice.replace(':zoneId', zoneId))
      if (result.data.code === 1) {
        // 存储未过滤的外部设备
        let origin = JSON.parse(JSON.stringify(result.data.data))
        $store.commit('SET_EXTSND', origin)
        let obj = {}
        result.data.data = result.data.data.reduce((cur, next) => {
          if (!(obj[next.deviceId] && obj[next.deviceId][next.nd])) {
            if (!obj[next.deviceId]) obj[next.deviceId] = {}
            obj[next.deviceId][next.nd] = true
            cur.push(next)
          }
          return cur
        }, [])
        result.data.data.sort((a, b) => {
          return a.nd - b.nd
        })
        // 对modbus做特殊处理
        let modbusList = origin.filter((item) => item.devicetype.key === 'airswitch')
        if (modbusList && modbusList.length) {
          modbusList &&
            modbusList.sort((a, b) => {
              return a.sid - b.sid
            })
          result.data.data = result.data.data.filter((item) => item.devicetype.key !== 'airswitch')
          modbusList.forEach((item) => {
            result.data.data.push(item)
          })
        }
        return result.data
      } else {
        throw new Error('获取外部设备信息失败')
      }
    } catch (e) {
      Vue._logger.error(e.message, e)
    }
  }
  async getOtherExtDeviceByzone (zoneId) {
    try {
      Vue._logger.debugger(Vue._config.api.otherExtDevice)
      const result = await Vue.axios.get(Vue._config.api.otherExtDevice.replace(':zoneId', zoneId))
      if (result.data.code === 1) {
        result.data.data.list.forEach((item) => {
          item.state = {
            state: 0
          }
        })
        // 存储未过滤的外部设备
        $store.commit('SET_OTHEREXT', result.data.data.list)
        // $store.commit('SET_OTHERTOKEN', result.data.data.token)
        return result.data.data.list || []
      } else {
        throw new Error('获取其他外部设备信息失败')
      }
    } catch (e) {
      Vue._logger.error(e.message, e)
    }
  }
  async getOtherExtDeviceByToken () {
    let error = ''
    try {
      Vue._logger.debugger(Vue._config.api.otherDeviceToken)
      const result = await Vue.axios.get(Vue._config.api.otherDeviceToken)
      if (result.data.code === 1) {
        $store.commit('SET_OTHERTOKEN', result.data.data.token)
        return result.data.data.token || {}
      } else {
        Vue._logger.error('获取其他外部设备智能插座token失败')
        Vue._logger.error(result.data)
        return error
        // throw new Error('获取其他外部设备智能插座token失败')
      }
    } catch (e) {
      Vue._logger.error(e.message, e)
      return error
    }
  }
  async getOtherExtState (deviceIds) {
    let list = []
    try {
      Vue._logger.debugger(Vue._config.api.otherExtState)
      if (!Array.isArray(deviceIds)) {
        deviceIds = [deviceIds]
      }
      for (let i = 0; i < deviceIds.length; i++) {
        const result = await Vue.axios.get(Vue._config.api.otherExtState, { params: { deviceId: deviceIds[i], channel: 1 } })
        if (result.data.code == 0) {
          list.push(result.data.data)
        } else {
          Vue._logger.error(deviceIds[i], result)
        }
      }
      return list
    } catch (e) {
      Vue._logger.error(e.message, e)
      return list
    }
  }
  upadataOtherExtState (otherExt, otherExtState) {
    try {
      otherExt.forEach((item) => {
        let obj = otherExtState.find((itm) => itm.deviceId === item.unique)
        if (obj) {
          item.state = {
            state: Number(obj.relayStatus),
            energy: obj.energy,
            totalEnergy: obj.totalEnergy
          }
        }
      })
      $store.commit('SET_OTHEREXT', otherExt)
    } catch (e) {
      Vue._logger.error(e.message, e)
    }
  }

  async getWeatherByZone (zoneId) {
    try {
      Vue._logger.debugger(Vue._config.api.weather)
      const result = await Vue.axios.get(Vue._config.api.weather + `?zoneId=${zoneId}`)
      if (result.data.code === 200) {
        return result.data
      } else {
        return null
      }
    } catch (e) {
      Vue._logger.error(e.message, e)
    }
  }

  async getSensorByDevice (deviceId) {
    try {
      Vue._logger.debugger(Vue._config.api.sensor)
      const result = await Vue.axios.get(Vue._config.api.sensor, { params: { coreid: deviceId } })
      if (result.data.code === 1) {
        return result.data
      } else {
        throw new Error('获取环境信息失败')
      }
    } catch (e) {
      Vue._logger.error(e.message, e)
    }
  }

  async getZoneTree (id) {
    try {
      Vue._logger.debugger(Vue._config.api.zone)
      const result = await Vue.axios.get(Vue._config.api.zoneTree.replace(':zoneId', id))
      if (result.data.code === 1) {
        return result.data.data
      } else {
        throw new Error('获取区域树信息失败')
      }
    } catch (e) {
      Vue._logger.error(e.message, e)
    }
  }

  getSensorByState (devices, deviceState) {
    let sensor = null
    let sensorNds = []
    devices.forEach((device) => {
      device.version = (deviceState[device.coreid] && deviceState[device.coreid].version) || 1
      device.connected = (deviceState[device.coreid] && deviceState[device.coreid].connected) || false
      if (deviceState[device.coreid] && deviceState[device.coreid].sensor && deviceState[device.coreid].sensor.length > 1) {
        // 新版处理光感变多个后的,区分光感和传感器的问题
        if (device.version >= 45 && device.ndlist) {
          let ndlist = JSON.parse(device.ndlist)
          let sensorNd = ndlist.filter((item) => item[3] === 12 && item[2] === 1).map((item) => item[0])
          sensorNd = [...sensorNd]
          sensorNds.push({
            deviceId: device.coreid,
            nds: sensorNd
          })
          deviceState[device.coreid].sensor = deviceState[device.coreid].sensor.filter((d) => sensorNd.includes(d.nd))
        } else {
          deviceState[device.coreid].sensor = deviceState[device.coreid].sensor.filter((d) => d.nd !== 138)
        }
      }
      // 存储sensor
      $store.commit('SET_SENSORND', sensorNds)

      // 查找最佳环境的逻辑，优先寻找时间最近的传感器
      if (sensor && deviceState[device.coreid] && deviceState[device.coreid].sensor && deviceState[device.coreid].sensor.length) {
        const newSensor = deviceState[device.coreid].sensor
          .sort((a, b) => {
            return new Date(b.lastHeard).getTime() - new Date(a.lastHeard).getTime()
          })
          .filter((d) => {
            return new Date(d.lastHeard).getTime() - new Date(sensor.lastHeard).getTime() > 0
          })
        if (newSensor.length) {
          sensor = newSensor[0]
        }
      } else if (deviceState[device.coreid] && deviceState[device.coreid].sensor && deviceState[device.coreid].sensor.length) {
        // 按时间排序，取得最新的一个环境
        const newSensor = deviceState[device.coreid].sensor.sort((a, b) => {
          return new Date(b.lastHeard).getTime() - new Date(a.lastHeard).getTime()
        })
        if (newSensor.length) {
          sensor = newSensor[0]
        }
      }
    })
    if (sensor) {
      $store.commit('UPDATE_SENSOR', sensor)
    }
  }

  getLightByState (lights, deviceState) {
    lights.forEach((bulb) => {
      bulb.name = bulb.device_name
      bulb.sid = bulb.sId
      bulb.nd = bulb.nodeId
      delete bulb.device_name
      delete bulb.sId
      delete bulb.nodeId
      delete bulb.ison
      if (deviceState[bulb.deviceId] && deviceState[bulb.deviceId].light) {
        const light = deviceState[bulb.deviceId].light.filter((l) => l.nd === bulb.nd)
        if (light.length && light[0].hasOwnProperty('State')) {
          bulb.state = light[0].State
        } else {
          bulb.state = 0
        }
        if (light.length && light[0].hasOwnProperty('CCT')) {
          bulb.cct = light[0].CCT
        } else {
          bulb.cct = 4500
        }
        if (light.length && light[0].hasOwnProperty('BR')) {
          bulb.brightness = light[0].BR
        } else {
          bulb.brightness = 75
        }
        if (light.length && light[0].hasOwnProperty('filter')) {
          bulb.filter = light[0].filter
        } else {
          bulb.filter = 0
        }
      } else {
        // 找不到给默认
        Object.assign(bulb, { cct: 4500, brightness: 75, filter: 0, state: 0 })
      }
    })
    // 显示层数据
    let obj = {}
    let lightsShow = lights.reduce((cur, next) => {
      obj[next.nd] ? '' : (obj[next.nd] = true && cur.push(next))
      return cur
    }, [])
    $store.commit('SET_LIGHT', lightsShow)
    // 原始数据
    $store.commit('SET_LIGHTS', lights)
  }

  getExtDeviceByState (extDevices, deviceState) {
    extDevices.forEach((ext) => {
      ext.state = {}
      if (deviceState[ext.deviceId]) {
        //  找得到控制器
        // 找到到指定设备类型，并且是数组
        if (deviceState[ext.deviceId][ext.devicetype.key] && Array.isArray(deviceState[ext.deviceId][ext.devicetype.key])) {
          let allTypeState = null
          if (ext.devicetype.key === 'airswitch' || ext.devicetype.key === 'lora_aricon') {
            allTypeState = deviceState[ext.deviceId][ext.devicetype.key].filter((air) => parseInt(air.nd) === ext.nd && air.addr === ext.sid)
          } else {
            allTypeState = deviceState[ext.deviceId][ext.devicetype.key].filter((air) => parseInt(air.nd) === ext.nd)
          }
          if (allTypeState.length && allTypeState[0] && ext.devicetype.key !== 'sensor' && (ext.devicetype.key !== 'remote' || ext.deviceKey === 91)) {
            // 找到的是合法数据
            Object.assign(
              ext,
              { state: Vue._config.defaultState[ext.devicetype.key] },
              {
                state: JSON.parse(JSON.stringify(this.extDeviceStateMapping(ext.devicetype.key, allTypeState[0]))) // 不同的设备，所返回的格式不同，需要处理
              }
            )
          } else {
            Object.assign(ext, { state: JSON.parse(JSON.stringify(Vue._config.defaultState[ext.devicetype.key])) })
          }
        } else if (deviceState[ext.deviceId][ext.devicetype.key]) {
          // 找到的不是数组
          // 直接按照一个处理
          Object.assign(
            ext,
            { state: JSON.parse(JSON.stringify(Vue._config.defaultState[ext.devicetype.key])) },
            { state: JSON.parse(JSON.stringify(this.extDeviceStateMapping(ext.devicetype.key, deviceState[ext.deviceId][ext.devicetype.key]))) }
          )
        } else {
          // 找不到指定类型
          Object.assign(ext, { state: JSON.parse(JSON.stringify(Vue._config.defaultState[ext.devicetype.key])) })
        }
      } else {
        Object.assign(ext, { state: JSON.parse(JSON.stringify(Vue._config.defaultState[ext.devicetype.key])) })
      }
    })
    // 显示层数据
    // let obj = {}
    // let extDevicesShow = extDevices.reduce((cur, next) => {
    //   obj[next.nd] ? '' : obj[next.nd] = true && cur.push(next)
    //   return cur
    // }, [])
    // // 对modbus做特殊处理
    // let modbusList = extDevices.filter(item => item.devicetype.key === 'airswitch')
    // if (modbusList && modbusList.length) {
    //   modbusList && modbusList.sort((a, b) => {
    //     return a.sid - b.sid
    //   })
    //   let index = modbusList.findIndex(item => item.devicetype.key === 'airswitch')
    //   delete modbusList[index]
    //   modbusList.forEach(item => {
    //     extDevicesShow.push(item)
    //   })
    // }
    $store.commit('SET_EXT', extDevices)
    // 原始数据
    $store.commit('SET_EXTS', extDevices)
  }

  extDeviceStateMapping (type, state) {
    let data = {}
    if (type === 'aircon') {
      if (state.hasOwnProperty('state')) {
        data.state = state.state
      }
      if (state.hasOwnProperty('tt')) {
        data.tt = state.tt
      }
      if (state.hasOwnProperty('air')) {
        data.air = state.air
      }
      if (state.hasOwnProperty('mode')) {
        data.mode = state.mode
      }
      return data
    } else if (type === 'airpure') {
      return { state: (state.state && true) || false, air: state.state }
    } else if (type === 'curtain') {
      return { state: state.state }
    } else if (type === 'switch') {
      return { state: (state.state && true) || false }
    } else if (type === 'colorbar') {
      // colorbar 被屏蔽仪暂用
      return { state: (state.state && true) || false }
      // return { state: (state.state && true) || false, color: state.state ? state.state : 'white' }
    } else if (type === 'fan') {
      return { state: (state.state && true) || false, air: state.state }
    } else if (type === 'airswitch') {
      // console.log(state)
      return { state: (state.state && true) || false, dl: state.dl || 0, dy: state.dy || 0, addr: state.addr, ady: state.ady || 0, bdy: state.bdy || 0, cdy: state.cdy || 0 }
    } else if (type === 'lora_aircon') {
      return { state: (state.state && true) || false, addr: state.addr, tt: state.tt, air: state.air, mode: state.mode }
    }
    else if (type === 'remote') {
      return { state: (state.state && true) || false }
    }
  }

  filterMenus (zoneId, light, ext, devices, otherExt) {
    const menus = ['device']
    // 定制 兼容教室照明
    let findExtLightClass = ext.find((f) => f.devicenodetype && f.devicenodetype === 205 && f.devicetype && f.devicetype.type === 6)
    if (findExtLightClass) menus.push('light_class')
    //  定制 qzdezx/0001 兼容门锁
    // if (zoneId === 1468 ) {
    if (zoneId === 5815) {
      menus.push('door_lock')
    }
    if (devices[0] && devices[0]['version'] >= 45) {
      menus.push('devicegroup')
    }
    if (light.length || ext.filter((d) => (d.devicetype.key === 'switch' && d.name.indexOf('射灯') > -1)).length) {
      menus.push('light')
    }
    ext.forEach((e) => {
      if (e.devicetype.key === 'switch' && e.name.indexOf('射灯') > -1) {
        // 忽略
      } else {
        const key = e.devicetype.key === 'remote' && e.deviceKey === 91 ? 'screen' : e.devicetype.key
        menus.push(key)
      }
    })
    otherExt.forEach((item) => {
      if (item.key === 'switch') {
        menus.push(item.key)
      }
    })
    if (Vue._config.monitor.filter((m) => m.no === $store.state.zone.no).length) {
      menus.push('video')
    }
    // TODO 临时写死的智慧空开
    menus.push('wisdom')
    $store.commit('SET_DEVICEMENUS', menus)
  }
}

export default new Zone()
